import { Chat } from './chatSettingsConfig'

export const isValidJid = (jid) => {
  if (!jid.includes(Chat.Settings.DOMAIN) && !jid.includes(Chat.Settings.MUC_DOMAIN)) {
    return false
  }
  return true
}

export const isPrivateChatRoom = (jid) => {
  return jid.startsWith(Chat.Settings.PRIVATE_CHAT_ROOM_PREFIX)
}

export const isVendorChatRoom = (jid) => {
  return jid.startsWith('V')
}

export const isChatRoom = (jid) => {
  return jid.includes(Chat.Settings.MUC_DOMAIN)
}

export const createChatRoomJid = ({ connection }) => {
  const uniqueId = connection.getUniqueId()
  const prefix = Chat.Settings.PRIVATE_CHAT_ROOM_PREFIX
  const jid = `${prefix}${uniqueId}@${Chat.Settings.MUC_DOMAIN}`
  return jid
}
